import React, { useState } from "react";
import { loginAdmin } from "../services/api";
import "./LoginPage.css";

function LoginPage({ onLogin, onBack }) {
  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      console.log("🔐 Attempting login with:", { username: formData.username });
      
      const res = await loginAdmin(formData);
      
      console.log("✅ Login response:", res.data);
      
      // Verify response has required data
      if (!res.data.token || !res.data.admin) {
        throw new Error("Invalid response format from server");
      }
      
      // Store JWT token in localStorage for API requests
      localStorage.setItem("authToken", res.data.token);
      console.log("✅ Token stored in localStorage");
      
      // Log before calling onLogin
      console.log("✅ Calling onLogin with admin data:", res.data.admin);
      
      // Call onLogin callback with admin info
      // This will update App.js state and store admin session
      onLogin(res.data.admin);
      
      console.log("✅ Login successful - Admin dashboard should now render");
      
    } catch (err) {
      console.error("❌ Login error:", err);
      const errorMessage = err.response?.data?.error || err.message || "Login failed";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__panel">
        <div className="login-page__brand">
          <img src="/logo.jpeg" alt="Bright Line Coaching" className="login-page__logo" />
          <div>
            <p>Bright Line Coaching</p>
            <h1>Admin Login</h1>
          </div>
        </div>

        {/* <p className="login-page__subtitle">
          Sign in to access the tuition management system.
        </p> */}

        <form className="login-page__form" onSubmit={handleSubmit}>
          <div className="login-page__field">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              name="username"
              type="text"
              value={formData.username}
              onChange={handleInputChange}
              placeholder="Enter username"
            />
          </div>

          <div className="login-page__field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Enter password"
            />
          </div>

          {error && <p className="login-page__error">{error}</p>}

          <button className="login-page__button" type="submit" disabled={loading}>
            {loading ? "Signing In..." : "Login"}
          </button>
        </form>

        {/* <div className="login-page__hint">
          <strong>Default Users</strong>
          <span>Admin: admin / admin1234</span>
          <span>Demo User: demouser / demo1234</span>
        </div> */}

        {onBack && (
          <button className="login-page__back-btn" type="button" onClick={onBack}>
            Back to Website
          </button>
        )}
      </div>
    </div>
  );
}

export default LoginPage;
